






































































import { ButtonType } from '@getaccept/lib-ui';
import { throttle } from '@getaccept/lib-shared/src/helpers';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed, ref, onBeforeUnmount } from '@vue/composition-api';
import SignaturePad from '../draw/components/SignaturePad.vue';
import WriteSignature from './WriteSignature.vue';

export default defineComponent({
  components: {
    SignaturePad,
    WriteSignature,
  },
  props: {
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
    },
    entity: {
      type: Object as PropType<Entity>,
      default: () => ({}),
    },
    documentName: {
      type: String,
      default: '',
    },
    inEditor: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const drawSignatureIsActive = ref(true);

    const writeSignatureData = ref({
      signatureBase30: '',
      signatureBase64: '',
    });

    const drawSignatureData = ref({
      signatureBase30: '',
      signatureBase64: '',
    });

    const isSmallHeightMode = ref(false);

    const tabs = computed(() => [
      {
        label: t('draw'),
        key: 'draw',
        isActive: drawSignatureIsActive.value,
      },
      {
        label: t('type'),
        key: 'type',
        isActive: !drawSignatureIsActive.value,
      },
    ]);

    const activeTab = computed(() => (drawSignatureIsActive.value ? 'draw' : 'type'));

    const signingInfoText = computed(
      () =>
        `${t('signature_by_hand_or_typing_v2', {
          recipientName: props.recipient.fullName,
          documentName: props.documentName,
        })}`
    );

    const signatureExists = computed(() => {
      const typeSignatureExist =
        writeSignatureData.value.signatureBase30 &&
        writeSignatureData.value.signatureBase64 &&
        !drawSignatureIsActive.value;

      const drawSignatureExist =
        drawSignatureData.value.signatureBase30 &&
        drawSignatureData.value.signatureBase64 &&
        drawSignatureIsActive.value;

      return !!(typeSignatureExist || drawSignatureExist);
    });

    const toggleSignatureType = () => {
      drawSignatureIsActive.value = !drawSignatureIsActive.value;
    };

    const handleCancel = () => {
      emit('cancel');
    };

    const handleSign = () => {
      if (drawSignatureIsActive.value) {
        emit('sign', drawSignatureData.value);
      } else {
        emit('sign', writeSignatureData.value);
      }
    };

    const handleReset = () => {
      drawSignatureData.value = {
        signatureBase30: '',
        signatureBase64: '',
      };
    };

    const handleDrawSignature = ({ signatureBase30, signatureBase64 }) => {
      drawSignatureData.value = {
        signatureBase30,
        signatureBase64,
      };
    };

    const handleWriteSignature = (signature: {
      signatureBase30: string;
      signatureBase64: string;
    }) => {
      if (signature.signatureBase30 && signature.signatureBase64) {
        writeSignatureData.value = signature;
      } else {
        writeSignatureData.value = {
          signatureBase30: '',
          signatureBase64: '',
        };
      }
    };

    const setScreenSize = () => {
      isSmallHeight();
    };

    const isSmallHeight = () => {
      isSmallHeightMode.value = window.innerWidth > window.innerHeight && window.innerHeight < 600;
    };

    const created = () => {
      window.addEventListener('resize', throttle(setScreenSize, 300));
      setScreenSize();
    };

    created();

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setScreenSize);
    });

    return {
      t,
      ButtonType,
      tabs,
      drawSignatureIsActive,
      signingInfoText,
      signatureExists,
      handleCancel,
      handleSign,
      handleReset,
      handleDrawSignature,
      handleWriteSignature,
      toggleSignatureType,
      isSmallHeightMode,
      setScreenSize,
      isSmallHeight,
      drawSignatureData,
      writeSignatureData,
      activeTab,
    };
  },
});
